
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings     from "../appsettings";
import * as dialog          from "../dialog";
import * as fileDownload    from "../fileDownload";
import * as main            from "../main";
import * as navigation      from "../navigation";
import * as viewmode        from "../viewmode";
import * as user            from "./user";
import * as grid            from "../grid";

export function getAdditionalData(): void { }

export function onDataBound(e: kendo.ui.GridDataBoundEvent): void { grid.saveGridOptions(e);}

export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as LCDGridVM;

    // Label
    const label = dataItem.FullName;

    // Edit mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("LCD/Edit?userId=" + dataItem.UserID + "&breadcrumbLabel=" + label);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as LCDGridVM;

    // Label
    const label = dataItem.FullName;

    // Edit mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("LCD/Edit?userId=" + dataItem.UserID + "&breadcrumbLabel=" + label);
}


export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour
        event.preventDefault();
        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as LCDGridVM;
        user.removeUser(dataItem.UserID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function extraToolbarButton1_Clicked(): void {
    const url = 'LCD/ExportAllLCDUsersNodesDown';
    const filename = 'Export_LCDAll_' + fileDownload.getDateTimeString() + '.xlsx';
    const loaderId = 'extraToolbarButton1Loader';
    fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
}

export function BSendNac_Clicked(userId: number): void {
    const selectedNacId = $("#NacId").data("kendoDropDownList").value();

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("LCD/Update_Provider_Nac") + "?userId=" + userId + "&nacId=" + selectedNacId,
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
            }
        }
    });
}

export function BSendCancelLocation_Clicked(userId: number): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("LCD/Send_Cancel_Location") + "?userId=" + userId,
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
            }
        }
    });
}
